import {IFlightsScheduleViewModel} from "./flights-schedule-view-model.interface";
import {Station} from "../../stations/station.service.interface";
import {
    FlightScheduleAvailabilityStatusEnum,
    IFlightDateScheduleAvailability
} from "../../flights-schedule/flights-schedule.service.interface";

export class VoidFlightsScheduleModel implements IFlightsScheduleViewModel {

    readonly datesRange: Date[] = [];
    getDateAvailability(date: Date): IFlightDateScheduleAvailability {
        return {
            status: FlightScheduleAvailabilityStatusEnum.NotAvailable
        };
    }

    getDateAvailabilityAsync(date: Date): Promise<IFlightDateScheduleAvailability> {
        return Promise.resolve(this.getDateAvailability(date));
    }

    get origin(): Station {
        throw new Error(`VoidFlightsScheduleModel doesn't support origin property`);
    }

    get destination(): Station {
        throw new Error(`VoidFlightsScheduleModel doesn't support destination property`);
    }

}
